import { useEffect, useRef } from 'react';

import { UseTimerFunc } from '@hh.ru/magritte-ui-timer/types';

export const useTimer: UseTimerFunc = (timeout, runner, tickCallback, paused) => {
    const cachedTimeout = useRef<number>(timeout);
    const cachedRunner = useRef(runner);
    const cachedTickCallback = useRef(tickCallback);
    const remainingTime = useRef<number>(timeout);

    useEffect(() => {
        if (timeout !== cachedTimeout.current) {
            remainingTime.current = timeout;
        }

        const end = Date.now() + remainingTime.current;
        let cleanupFunc: VoidFunction;

        const nextTickFunc = (): void => {
            const now = Date.now();
            cachedTickCallback.current((end - now) / timeout);
            remainingTime.current = end - now;

            if (now > end) {
                return;
            }

            cleanupFunc = cachedRunner.current(nextTickFunc);
        };

        if (!paused) {
            nextTickFunc();
        }

        return () => {
            cleanupFunc?.();
        };
    }, [timeout, paused]);
};
